<script setup lang="ts">
import { getRecordUrl } from "@/common/records"
defineProps<{ to: { type: string; slug: string; name?: string } }>()
</script>

<template>
  <router-link :to="getRecordUrl(to)">
    <slot>{{ to.name }}</slot>
  </router-link>
</template>
